"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RUN = RUN;
exports.WARN = WARN;
exports.createRealtimeLogManager = createRealtimeLogManager;
var RealtimeLogManager = wx.getRealtimeLogManager ? wx.getRealtimeLogManager() : null;
var VERSION = '';

function ERROR(event, data) {
  if (RealtimeLogManager) {
    var TraceId = data.TraceId,
        type = data.type;
    RealtimeLogManager.error(event, data); // 判断是否支持设置模糊搜索
    // 错误的信息可记录到 FilterMsg，方便搜索定位

    if (RealtimeLogManager.addFilterMsg) {
      try {
        RealtimeLogManager.addFilterMsg("[".concat(VERSION, "] ").concat(TraceId, " ").concat(event, " ").concat(type, " "));
      } catch (e) {
        RealtimeLogManager.setFilterMsg("[".concat(VERSION, "] ").concat(event));
      }
    }
  }
}

function WARN(event, data) {
  RealtimeLogManager && RealtimeLogManager.warn(event, data);
}

function RUN(event, data) {
  data.level = 'info';
  RealtimeLogManager && RealtimeLogManager.info(event, data);
}
/**
 * @description: 根据标签创建实时日志管理器实例
 * @return {RealtimeLogManager} RealtimeLogManager
 */


function createRealtimeLogManager(version) {
  VERSION = version;
  if (!RealtimeLogManager) return;
  return {
    error: function error() {
      ERROR.apply(void 0, arguments);
    },
    warn: function warn() {
      WARN.apply(void 0, arguments);
    },
    debug: function debug() {
      WARN.apply(void 0, arguments);
    },
    info: function info() {
      RUN.apply(void 0, arguments);
    },
    log: function log() {
      RUN.apply(void 0, arguments);
    }
  };
}